<template>
  <el-container>
    <el-header id="header" height="40px" style="line-height: 40px;padding-top: 5px">
      <el-form ref="searchForm" :inline="true" :model="formQuery" :rules="rules" size="small">
        <el-form-item>
          <el-switch
            v-model="formQuery.source"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="lis"
            inactive-text="his/体检"
            :active-value="1"
            :inactive-value="0"
            @change="switchSpecTypeHandle">
          </el-switch>
        </el-form-item>
        <el-form-item label="条码" prop="barcode">
          <el-input v-model="formQuery.barcode" placeholder="条码"></el-input>
        </el-form-item>
        <el-form-item label="送检机构id" prop="fromOrgId">
          <el-select v-model="formQuery.fromOrgId" filterable placeholder="请选择送检机构">
            <el-option
              v-for="item in orgs"
              :key="item.dispatch_org_id"
              :label="item.name"
              :value="item.dispatch_org_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检验机构id" prop="toOrgId">
          <!--<el-input v-model="formQuery.toOrgId" placeholder="检验机构id"></el-input>-->
          <el-select v-model="formQuery.toOrgId" filterable placeholder="请选择检验机构">
            <el-option
              v-for="item in orgs"
              :key="item.dispatch_org_id"
              :label="item.name"
              :value="item.dispatch_org_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-loading.fullscreen="isLoading" @click="searchHandle">查询</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main v-bind:style="containerStyle">
      <el-scrollbar ref="scrollbar" style="height: 100%;">
        <!--:active="3"-->
        <el-steps direction="vertical" :active="activeStepIndex" inish-status="process">
          <el-step v-for="(item, index) in specTrackers" :key="index"> <!-- :title="item.title" -->
            <template slot="title">
              {{item.title}}&nbsp;
              <i class="el-icon-info" v-if="item.key == activeStepKey" @click="showStepInfoHandle"
                 style="cursor: pointer"></i>
            </template>
            <template class="step-item" slot="description">
              <div v-html="specTrackerInfo(item.key)"></div>
              <!--<div>-->
              <!--<i class="el-icon-info"></i>-->
              <!--</div>-->
            </template>
          </el-step>
        </el-steps>
      </el-scrollbar>
    </el-main>
    <el-dialog title="数据" :visible.sync="dlgStepInfoVisible" width="600px" center>
      <json-viewer
        :value="activeData"
        :expand-depth=10
        :copyable="true"
        :boxed="true"
      ></json-viewer>
      <span slot="footer" class="dialog-footer" style="line-height: 40px; text-align: center">
          <el-button type="primary" size="mini" plain @click="closeStepInfoHandle" icon="iconfont icon-close"></i>
            关 闭
          </el-button>
      </span>
    </el-dialog>
  </el-container>

</template>

<script>
  import Vue from 'vue'
  import {mapGetters} from 'vuex';
  import jsonView from 'vue-json-viewer'

  import specTrackersHis from '../../../static/specTracker/specTracker-his';//his的结点
  import specTrackersLis from '../../../static/specTracker/specTracker-lis';//lis的结点
  //his结点10-15的描述
  import specTracker10 from '!raw-loader!../../../static/specTracker/specTracker-10.txt'
  import specTracker11 from '!raw-loader!../../../static/specTracker/specTracker-11.txt'
  import specTracker12 from '!raw-loader!../../../static/specTracker/specTracker-12.txt'
  import specTracker13 from '!raw-loader!../../../static/specTracker/specTracker-13.txt'
  import specTracker14 from '!raw-loader!../../../static/specTracker/specTracker-14.txt'
  import specTracker15 from '!raw-loader!../../../static/specTracker/specTracker-15.txt'
  //lis结点20-28的描述
  import specTracker20 from '!raw-loader!../../../static/specTracker/specTracker-20.txt'
  import specTracker21 from '!raw-loader!../../../static/specTracker/specTracker-21.txt'
  import specTracker22 from '!raw-loader!../../../static/specTracker/specTracker-22.txt'
  import specTracker23 from '!raw-loader!../../../static/specTracker/specTracker-23.txt'
  import specTracker24 from '!raw-loader!../../../static/specTracker/specTracker-24.txt'
  import specTracker25 from '!raw-loader!../../../static/specTracker/specTracker-25.txt'
  import specTracker26 from '!raw-loader!../../../static/specTracker/specTracker-26.txt'
  import specTracker27 from '!raw-loader!../../../static/specTracker/specTracker-27.txt'
  import specTracker28 from '!raw-loader!../../../static/specTracker/specTracker-28.txt'

  Vue.use(jsonView)

  const SPEC_TYPE_LIS = 1;//lis对接类型
  const SPEC_TYPE_HIS = 0;//his/体检对接类型

  const SPEC_TRANCKER_INFO_HIS = new Map([
    ['10', specTracker10],
    ['11', specTracker11],
    ['12', specTracker12],
    ['13', specTracker13],
    ['14', specTracker14],
    ['15', specTracker15]
  ]);
  const SPEC_TRACKER_INFO_LIS = new Map([
    ['20', specTracker20],
    ['21', specTracker21],
    ['22', specTracker22],
    ['23', specTracker23],
    ['24', specTracker24],
    ['25', specTracker25],
    ['26', specTracker26],
    ['27', specTracker27],
    ['28', specTracker28]
  ]);

  export default {
    data() {
      return {
        formQuery: {
          barcode: '442187436700',
          fromOrgId: '',
          toOrgId: '',
          source: SPEC_TYPE_LIS//对接类型：0-his/体检；1-lis
        },
        orgs: [],
        specTrackers: [],
        specTrackersHis,
        specTrackersLis,
        specTrackerInfos: new Map([]),
        activeData: null,//流程当前步骤的数据
        activeStepIndex: 0,//流程当前步骤
        activeStepKey: '',//流程当前步骤关键字
        dlgStepInfoVisible: false,//是否（弹框）显示当前流程的数据
        rules: {
          barcode: [
            {required: true, message: '请输入条码号', trigger: 'blur'},
          ],
          fromOrgId: [
            {required: true, message: '请输入送检机构id', trigger: 'blur'},
          ]
        },
      }
    },
    props: {
      myHeight: {
        type: Number
      }
    },
    computed: {
      ...mapGetters(['isLoading']),
      containerStyle() {
        const _this = this;
        return {
          height: _this.getMainHeight() + 'px',
          maxHeight: _this.getMainHeight() + 'px'
        }
      }
    },
    components: {},
    created() {

    },
    mounted() {
      this.switchSpecTypeHandle();
      this.loadOrgs();
    },
    methods: {
      /**
       * 显示结点信息
       * @param key
       * @returns {*}
       */
      specTrackerInfo(key) {
        const _this = this;

        if (!_this.specTrackerInfos.has(key)) {
          return '';
        }
        if (_this.activeData == null || (_this.activeData.errorMsg || '').trim().length == 0 || key != _this.activeStepKey) {
          return _this.specTrackerInfos.get(key);
        }
        return (_this.activeData.errorMsg || '').trim() + '<br/>' + _this.specTrackerInfos.get(key);
      },
      getMainHeight() {
        const _this = this;
        //获取窗体主工作区域的高度
        return (_this.myHeight - $('#header').height());
      },
      onresize() {
        //console.debug("onresize ...")
        const _this = this;
        setTimeout(function () {
          _this.$refs.scrollbar.update();
        }, 300);
      },
      initStepTracker() {
        const _this = this;

        _this.activeStepIndex = 0;
        _this.activeStepKey = '';
        _this.activeData = null;


        // _this.$api.
      },
      /**
       * 点击搜索
       */
      searchHandle() {
        const _this = this;
        _this.initStepTracker();
        //验证成功后提交保存
        this.$refs['searchForm'].validate((valid) => {
          if (valid) {
            _this.$store.dispatch('loading');

            _this.apiSpecTracker.getSpecTracker(_this.formQuery,
              (response) => {
                _this.activeData = Object.assign({}, response);
                if (!_this.activeData.success) {
                  throw Error('未能正常获取到数据' + (_this.activeData.errorMsg ? `异常信息：${_this.activeData.errorMsg}` : ''));
                  //throw Error('未能正常获取到数据');
                }
                //判断结点编号是否有效
                if (!_this.specTrackerInfos.has(_this.activeData.errorCode)) {
                  _this.$message.warning(`结点编号${_this.activeData.errorCode}无效`);
                  _this.$store.dispatch('loaded');
                  return;//todo
                }

                _this.activeStepKey = _this.activeData.errorCode || 0;//结点编号
                let keys = Array.from(_this.specTrackerInfos.keys());//MapIterator转数组
                let keyIndex = keys.indexOf(_this.activeData.errorCode + '');
                if (keyIndex == -1) {
                  _this.activeStepIndex = 0;
                } else {
                  _this.activeStepIndex = keyIndex + 1;
                }
                _this.$store.dispatch('loaded');
              },
              (error) => {
                //_this.$message.error(error.message);
                _this.$notify({
                  title: '错误',
                  message: error.message,
                  type: 'error',
                  position: 'bottom-right'
                });
                _this.$store.dispatch('loaded');
              })
          } else {
            return false;
          }
        })
      },
      /**
       * 显示数据(弹框)
       */
      showStepInfoHandle() {
        this.dlgStepInfoVisible = true;
      },
      /**
       * 关闭数据(弹框)
       */
      closeStepInfoHandle() {
        this.dlgStepInfoVisible = false;
      },
      switchSpecTypeHandle() {
        const _this = this;
        _this.initStepTracker();

        if (_this.formQuery.source == SPEC_TYPE_LIS) {
          _this.specTrackers = _this.specTrackersLis;
          _this.specTrackerInfos = SPEC_TRACKER_INFO_LIS;
        } else {
          _this.specTrackers = _this.specTrackersHis;
          _this.specTrackerInfos = SPEC_TRANCKER_INFO_HIS;
        }
      },
      loadOrgs() {
        const _this = this;

        _this.orgs = [];
        // if (_this.$store.state.areaOrgs) {
        //   _this.orgs = Object.assign({}, _this.$store.state.areaOrgs);
        // } else {
          _this.$store.dispatch('loading');
          //清除区域机构
          _this.orgs = [];
          _this.$store.dispatch('setAreaOrgs', null);

          _this.apiSystem.getAreaOrgs(_this.$store.state.userInfo.org_id,
            (orgs) => {
              _this.orgs = orgs;
              _this.$store.dispatch('setAreaOrgs', orgs);//区域机构
              _this.$store.dispatch('loaded');
            },
            (error) => {
              _this.$notify({
                title: '错误',
                message: error.message,
                type: 'error',
                position: 'bottom-right'
              });
              _this.$store.dispatch('loaded');
            });
        // }
      }
    },
  }
</script>

<style scoped lang="scss">
  .step-item {
    background: #f5f7fa;
  }
</style>



// WEBPACK FOOTER //
// src/views/specTracker/TrackerIndex.vue